export default {
    data(){
        return{
            months: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
            longmonths:['January','February','March','April','May','June','July','August','September','October','November','December'],
            baseurl: "http://eposplus.sytes.net/gymmanagementsolution/api/",
            //baseurl: "https://localhost:7009/",
            //baseurl: "http://192.168.1.200/gymmanagementsystem/api/",
            homeurl: "/gymmanagementsolution",
            //homeurl: "/",
            //homeurl: "/gymmanagementsystem",
            loginurl: "/gymmanagementsolution/#/login",
            //loginurl: "/#/login",
            //loginurl: "/gymmanagementsystem/#/login",
            filename: null,
            filters:{
                page: null,
                displayentries: 99999999,
                q: null
            },
            access: {
                DASHBOARD: false,
                MEMBERSHIP: false,
                PLAN: false,
                DISCOUNTS: false,
                BIOMETRICS: false,
                COACHDUTY: false,
                COACHATTENDANCE: false,
                CLASS: false,
                MERCHANDISEPRODUCT: false,
                MERCHANDISEPRODUCTGROUP: false,
                PHYSICALCOUNT: false,
                POS: false,
                REPORTS: false,
                ROLES: false,
                USERS: false,
                MEMBERSHIPMONITORING: false,
                DAILYSALES: false,
                INVENTORYREPORT: false,
                PTREPORT: false,
                CLASSREPORT: false
            },
        }
    },

    filters:{
        currencyformat(data){
            const money = (data/1).toFixed(2).replace(',', '.')
            return money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
    },

    mounted(){
        if(localStorage.getItem("token") != null){
            this.loadaccesslevel()
        }
    },

    methods:{
        formatshortdate(mydate) {
            let d = new Date(mydate)
            let month = '' + (d.getMonth() + 1)
            let day = '' + d.getDate()
            let year = d.getFullYear()
            if (month.length < 2)
                month = '0' + month
            if (day.length < 2)
                day = '0' + day
            return [this.months[month - 1] + ' ' + day, year].join(', ')
        },
        formatdate(mydate) {
            let d = new Date(mydate)
            let month = '' + (d.getMonth() + 1)
            let day = '' + d.getDate()
            let year = d.getFullYear()
            if (month.length < 2)
                month = '0' + month
            if (day.length < 2)
                day = '0' + day
            return [year, month, day].join('-')
        },

        formatmonthyear(mydate) {
            let d = new Date(mydate)
            let month = '' + (d.getMonth() + 1)
            let day = '' + d.getDate()
            let year = d.getFullYear()
            if (month.length < 2)
                month = '0' + month
            if (day.length < 2)
                day = '0' + day
            return [this.longmonths[month - 1], year].join(' ')
        },
        mcurrencyformat(data){
            const money = (data/1).toFixed(2).replace(',', '.')
            return money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

        //FILE UPLOADING
        async onFileUploading(file){
            const formData = new FormData()
            formData.append('files', file, file.name)
            await this.axios.post("User/fileuploader", formData).then((response) => {
                if(response.data.error == false){
                    this.filename = response.data.filename;
                }
            })
        },

        async loadaccesslevel(){
            await this.axios.get("AccessLevel/get-accesslevelbyusername").then((response) => {
                if(response.data.error == false){
                    response.data.accesslevels.forEach((value) => {
                        if(value.moduleName == "DASHBOARD"){
                            this.access.DASHBOARD = true
                        }

                        if(value.moduleName == "MEMBERSHIP"){
                            this.access.MEMBERSHIP = true
                        }

                        if(value.moduleName == "PLAN"){
                            this.access.PLAN = true
                        }

                        if(value.moduleName == "DISCOUNTS"){
                            this.access.DISCOUNTS = true
                        }

                        if(value.moduleName == "BIOMETRICS"){
                            this.access.BIOMETRICS = true
                        }

                        if(value.moduleName == "COACHDUTY"){
                            this.access.COACHDUTY = true
                        }

                        if(value.moduleName == "COACH ATTENDANCE"){
                            this.access.COACHATTENDANCE = true
                        }

                        if(value.moduleName == "CLASS"){
                            this.access.CLASS = true
                        }

                        if(value.moduleName == "MERCHANDISE PRODUCT"){
                            this.access.MERCHANDISEPRODUCT = true
                        }

                        if(value.moduleName == "MERCHANDISE PRODUCT GROUP"){
                            this.access.MERCHANDISEPRODUCTGROUP = true
                        }

                        if(value.moduleName == "PHYSICALCOUNT"){
                            this.access.PHYSICALCOUNT = true
                        }

                        if(value.moduleName == "POS"){
                            this.access.POS = true
                        }

                        if(value.moduleName == "REPORTS"){
                            this.access.REPORTS = true
                        }

                        if(value.moduleName == "ROLES"){
                            this.access.ROLES = true
                        }

                        if(value.moduleName == "USERS"){
                            this.access.USERS = true
                        }

                        if(value.moduleName == "MEMBERSHIP MONITORING"){
                            this.access.MEMBERSHIPMONITORING = true
                        }

                        if(value.moduleName == "DAILY SALES"){
                            this.access.DAILYSALES = true
                        }

                        if(value.moduleName == "INVENTORY REPORT"){
                            this.access.INVENTORYREPORT = true
                        }

                        if(value.moduleName == "PT REPORT"){
                            this.access.PTREPORT = true
                        }

                        if(value.moduleName == "CLASS REPORT"){
                            this.access.CLASSREPORT = true
                        }
                    })
                }
            }).catch((error) => {
                console.log(error)
            })
        },

        tConvert (time) {
            // Check correct time format and split into components
            time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
          
            if (time.length > 1) { // If time format correct
              time = time.slice (1);  // Remove full string match value
              time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
              time[0] = +time[0] % 12 || 12; // Adjust hours
            }
            return time.join (''); // return adjusted time or original string
          }
          
        
    }
    
}